import React, { useEffect, useRef, useState } from 'react'
import styles from './styles.module.css'
import { debounce } from 'lodash';

const MultilineInput = ({ label, maxChars, setText, placeholder, value = '', disabled = false, debounceSetText = false }) => {
    const [count, setCount] = useState(value.length);
    const [currentText, setCurrentText] = useState(value);

    useEffect(() => {
        setCount(value.length);
        setCurrentText(value);
    }, [value]);

    const debouncedSetText = useRef(
        debounce((text) => {
            setText(text);
        }, 3000)
    );

    const handleUpdateText = (e) => {
        const eventValue = e.target.value;
        setCurrentText(eventValue);
        setCount(eventValue.length);
        if (debounceSetText) {
            debouncedSetText.current(eventValue);
        } else {
            setText(eventValue);
        }
    };


    return (
        <div className={styles.inputContainer}>
            <label className={styles.label}>{label}</label>
            <textarea
                placeholder={placeholder ? placeholder : 'Enter description...'}
                className={styles.messageInput}
                onChange={handleUpdateText}
                maxLength={maxChars}
                defaultValue={currentText}
                disabled={disabled} />
            {maxChars &&
                <div className={styles.wordCountContainer}>
                    <span className={styles.wordCountText}>{count}/{maxChars} characters</span>
                </div>}
        </div>
    )
}

export default MultilineInput;